import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-profile-header',
    templateUrl: './profile-header.component.html',
    styleUrls: ['./profile-header.component.scss'],
    standalone: false
})
export class ProfileHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
